import React, { ReactElement } from 'react'

import { IconType } from 'react-icons'

import { useUser } from '../../../../context'
import {
  ContentCard,
  ContentIcon,
  ContentDescription,
  Tooltip,
} from '../styles'

const Card = ({
  Icon,
  amount,
  title,
  hoverText,
}: {
  title: string | ReactElement
  amount: number
  Icon?: IconType | string
  hoverText?: string
}) => {
  const { userRole } = useUser()

  return (
    <ContentCard $userRole={userRole}>
      {Icon && typeof Icon === 'string' ? (
        <ContentIcon $userRole={userRole}>
          <img src={Icon} alt="icon" />
        </ContentIcon>
      ) : (
        <ContentIcon $userRole={userRole}>
          {Icon && typeof Icon !== 'string' && <Icon />}
        </ContentIcon>
      )}

      <ContentDescription $userRole={userRole}>
        {userRole === 'student' ? (
          <div className="number-text" style={{ whiteSpace: 'pre-line' }}>
            <span className="number">{amount}</span> {title}
          </div>
        ) : (
          <>
            <div className="number">{amount}</div>
            <div className="number-text">{title}</div>
          </>
        )}
      </ContentDescription>
      {hoverText && <Tooltip>{hoverText}</Tooltip>}
    </ContentCard>
  )
}

export default Card
